import { useState } from "react";

import CreateRecordButtonLayout from "../layout/CreateRecordButtonLayout";
import MomSysOrderPurchaseDetailPstMaterialRegisterDialog from "../dialogTypes/MomSysOrderPurchaseDetailPstMaterialRegisterDialog";

function MomSysOrderPurchaseDetailPstMaterialRegisterButton(props) {
    const {
        id,
        schema,
        onSuccess,
        customizeErrorMsgCallback,
        onDialogUpdateDetail,
        orderPurchaseMstSelect,
        ...others
    } = props;

    const [open, setOpen] = useState(false);

    const onOpen = () => {
        setOpen(true);
    };

    const onClose = () => {
        setOpen(false);
    };

    const onCreateSuccess = (msg) => {
        if (onSuccess) {
            onSuccess(msg);
        }
    };

    return (
        <>
            <CreateRecordButtonLayout
                id={id + "-pst-material-register-button"}
                onClick={onOpen}
                createButtonName={"orderPurchaseDetailPstMaterialRegister"}
                {...others}
            />
            <MomSysOrderPurchaseDetailPstMaterialRegisterDialog
                id={id + "-pst-material-register-dialog"}
                mode="create"
                schema={schema}
                open={open}
                onClose={onClose}
                onSuccess={onCreateSuccess}
                onDialogUpdateDetail={onDialogUpdateDetail}
                orderPurchaseMstSelect={orderPurchaseMstSelect}
                customizeErrorMsgCallback={customizeErrorMsgCallback}
            />
        </>
    );
}

export default MomSysOrderPurchaseDetailPstMaterialRegisterButton;
